export default {
    getChannelInfoForChatbox: async( { backEndService, channelKey }, content = {}) => {
        const url = `${backEndService}/channel/${channelKey}/info`;

        // headers Content-type json is really important
        content.headers = content.headers ? content.headers : {};
        const headers = { 'Content-Type': 'application/json', 'X-Talkr-Query' : '1'};
        content.headers = {...content.headers, ...headers}

        return await fetch(url, content).then((response) =>  response.json());
    },
}